import React from "react";
import { useParams } from "react-router-dom";
import ResponsiveMapWrapper from "../../components/ResponsiveMapWrapper";

interface RegionMapProps {
  contentType?: "trekkings" | "experiences";
  groupId?: string;
  focusTrailId?: string;
  focusPoiId?: string; // ← AGGIUNTO
}

const RegionMap: React.FC<RegionMapProps> = ({
  contentType = "trekkings",
  groupId = undefined,
  focusTrailId = undefined,
  focusPoiId = undefined, // ← AGGIUNTO
}) => {
  const { name } = useParams<{ name: string }>();

  if (!name) {
    console.error("Nome regione mancante");
    return <div>Errore: regione non specificata</div>;
  }

  console.log("🔍 RegionMap render:", { name, contentType, groupId });

  if (contentType === "trekkings") {
    return (
      <ResponsiveMapWrapper
        key={`${name}-hiking`}
        nameRegion={name}
        folder={"hiking"}
        contentType={contentType}
        groupId={groupId}
        focusTrailId={focusTrailId}
      />
    );
  }

  if (contentType === "experiences") {
    return (
      <ResponsiveMapWrapper
        key={`${name}-activity`}
        nameRegion={name}
        folder={"activity"}
        contentType={contentType}
        groupId={groupId}
        focusPoiId={focusPoiId} // ← AGGIUNTO solo per experiences
      />
    );
  }

  return <div>Tipo contenuto non valido</div>;
};

export default RegionMap;
